import { noteNameToPitch, noteNames } from "./utils"

export default class Note {
    constructor( pitch ) {
        this.pitch = pitch
    }
}